import { render, staticRenderFns } from "./order-pad-header.vue?vue&type=template&id=730dc40b"
import script from "./order-pad-header.vue?vue&type=script&lang=js"
export * from "./order-pad-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports